import React from 'react';
import { Card, CardContent } from '../ui/card';
import { whatToExpect } from '../../enhancedMock';
import { iconMap } from './iconMap';

export const WhatToExpect = () => (
  <section data-testid="what-to-expect-section" className="fade-in-section py-12 md:py-20 px-4 bg-white/80 backdrop-blur-sm relative z-10">
    <div className="container mx-auto max-w-5xl">
      <div className="text-center mb-10 md:mb-16">
        <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-darkBrown mb-4">What to Expect</h2>
        <p className="text-sm md:text-xl text-gray-600">Your journey to better mental health starts here</p>
        <div className="w-24 h-1 bg-primaryOrange mx-auto mt-4"></div>
      </div>

      <div className="space-y-4 md:space-y-6">
        {whatToExpect.map((step) => {
          const Icon = iconMap[step.icon];
          return (
            <Card key={step.step} className="border-none shadow-lg hover:shadow-xl transition-all bg-white">
              <CardContent className="p-4 md:p-6 flex items-start gap-4 md:gap-6">
                <div className="flex-shrink-0">
                  <div className="w-12 h-12 md:w-16 md:h-16 bg-primaryOrange rounded-full flex items-center justify-center text-white text-lg md:text-2xl font-bold">
                    {step.step}
                  </div>
                </div>
                <div className="flex-1">
                  <div className="flex items-center gap-2 md:gap-3 mb-1 md:mb-2">
                    <Icon className="text-primaryOrange" size={20} />
                    <h3 className="text-lg md:text-2xl font-bold text-darkBrown">{step.title}</h3>
                  </div>
                  <p className="text-sm md:text-lg text-gray-600">{step.description}</p>
                </div>
              </CardContent>
            </Card>
          );
        })}
      </div>
    </div>
  </section>
);
